module.exports = __webpack_public_path__ + "img/detail_link_img.56a65040.png";